export enum ShopApiList {
  GetShopPage = '/api/v2/shop',
}
